import {
  assignDealer,
  markOrderAsDuplicate,
  markOrderAsImpossible,
  resetToCreated,
} from '../../../services/ApiService'

export const switchCurrentUpdateFunction = (status: number) => {
  switch (status) {
    case 1:
      return resetToCreated
    case 2:
      return assignDealer
    case 7:
      return markOrderAsImpossible
    default:
      return markOrderAsDuplicate
  }
}
